import { AxiosError } from "axios";
import { DeepPartial, Video, VideoEmbedSettings } from "vimeo";
import { client as vimeoClient } from "../../vimeoClient";

export async function updateEmbedSettings(
    video: Video,
    embedSettings: DeepPartial<VideoEmbedSettings>
): Promise<Video> {
    const videoUri = video.uri.replace("/", "");
    const resp = await vimeoClient.patch<Video>(
        `/api/vimeo/${videoUri}`,
        {
            embed: {
                ...embedSettings,
            },
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return resp.data;
}

function getPresetIdFromUri(uri: string): string {
    return uri.split("/")[4];
}

export async function isEmbedPresetAddedToVideo(
    presetUri: string,
    videoUri: string
): Promise<{ added: boolean; presetUri: string }> {
    // Preset URIs are of the form /users/:userId/presets/:presetId.
    const presetId = getPresetIdFromUri(presetUri);
    try {
        const resp = await vimeoClient.get(
            `/api/vimeo${videoUri}/presets/${presetId}`
        );
        if (resp.status === 200 || resp.status === 204) {
            return { added: true, presetUri };
        }
    } catch (err: any) {
        const axiosError: AxiosError = err;
        // We expect to receive a 404 if the embed preset has not been
        // added to the video. Any other error status code could be a genuine
        // error, so re-throw it.
        if (axiosError.response?.status !== 404) {
            throw err;
        }
    }

    return { added: false, presetUri };
}

export async function addEmbedPresetToVideo(
    presetUri: string,
    videoUri: string
): Promise<void> {
    const presetId = getPresetIdFromUri(presetUri);
    await vimeoClient.put(`/api/vimeo${videoUri}/presets/${presetId}`);
}

export async function deleteEmbedPresetFromVideo(
    presetUri: string,
    videoUri: string
): Promise<void> {
    const presetId = getPresetIdFromUri(presetUri);
    await vimeoClient.delete(`/api/vimeo${videoUri}/presets/${presetId}`);
}
